// Mission step UI adapter.
//
// Converts raw Laravel mission_step records (snake_case, as returned by
// missionStepService) into the minimal camelCase shape the mission-step UI
// components need. Data mapping only — no JSX/icon rendering happens here.

export function mapMissionStepForUI(step) {
  return {
    id: step.id,
    stepKey: step.step_key,
    stepNumber: step.step_number,
    title: step.title,
    subtitle: step.subtitle ?? null,
    hint: step.hint ?? null,
    ctaLabel: step.cta_label ?? null,
    iconKey: step.icon_key ?? null,
    color: step.color ?? null,
    stepOrder: step.step_order ?? null,
    journeyId: step.journey_id ?? null,
  };
}

export function mapMissionStepsForUI(steps) {
  return steps.map(mapMissionStepForUI);
}
